const settings = {
    clock_border_color: {
        input: 'text',
        value: '#000000'
    },
    clock_face_color: {
        input: 'text',
        value: '#FFFFFF'
    },
    clock_numbers_color: {
        input: 'text',
        value: '#000000'
    },
    clock_number_ticks_color: {
        input: 'text',
        value: '#000000'
    },
    clock_hour_hand_color: {
        input: 'text',
        value: '#000000'
    },
    clock_minute_hand_color: {
        input: 'text',
        value: '#000000'
    },
    clock_seconds_hand_color: {
        input: 'text',
        value: '#000000'
    },
    background_color: {
        input: 'text',
        value: '#282c34'
    },
    button_color: {
        input: 'text',
        value: '#FFFFFF'
    }
};

module.exports = settings;